// Color palettes + pure color helpers shared by InteractiveGraph renderers.
//
// MOVED here verbatim from InteractiveGraph.js (module-level pure constants and
// functions; the only change is the `export ` keyword added to each moved
// top-level declaration) as maintenance-only Slice 2 of the InteractiveGraph
// split — same "verbatim move + single source" pattern as Slice 1 (#42,
// utils/{chartLayout,legendMetrics,functionGraphLabels}.js). InteractiveGraph
// imports getCUDPalette / EXTENDED_COLOR_PALETTE / normalizeColorKey /
// mixColors / toRgba / getConsistentIndexFromId back, so every call site is
// unchanged; CUD_PALETTES is consumed only by getCUDPalette (and tests).
// Behavior must stay byte-identical: do NOT add component-/state-aware logic
// here.
//
// NOTE: color-preference *storage* helpers (COLOR_PREFERENCE_STORAGE_PREFIX,
// normalizeColorPreferenceScope, buildColorPreferenceStorageKey, ...) and the
// DEFAULT_*_COLOR constants intentionally stay in InteractiveGraph.js — they
// are outside the Slice 2 color pure-function group.

import * as d3 from 'd3';
import { clamp01 } from './chartLayout';

// ── CUD配色プリセットマッピング ──
export const CUD_PALETTES = {
  auto: ['#ef4444', '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316'],
  accent_cud: ['#FF2800', '#0041FF', '#35A16B', '#FAF500', '#FF99A0', '#9B7CB6', '#FFB500', '#00B7CE'],
  base_cud: ['#FFD1D1', '#B4EBFA', '#CBF266', '#FFFF99', '#FFCABF', '#D7C4E2', '#FFE4B5', '#C2EFEF'],
  neutral_cud: ['#000000', '#C8C8CB', '#7F878F', '#FFFFFF', '#4D4D4D', '#A0A0A0', '#E0E0E0', '#333333'],
};

export const getCUDPalette = (presetName) => CUD_PALETTES[presetName] || CUD_PALETTES.auto;

export const EXTENDED_COLOR_PALETTE = [
  '#f472b6',
  '#fb7185',
  '#f97316',
  '#facc15',
  '#4ade80',
  '#34d399',
  '#22d3ee',
  '#38bdf8',
  '#818cf8',
  '#a855f7',
  '#ec4899',
  '#fb7185'
];

export const normalizeColorKey = (value) => {
  if (!value || typeof value !== 'string') return null;
  const cleaned = value.trim().toLowerCase().replace(/\s+/g, '');
  return cleaned || null;
};

export const mixColors = (colorA, colorB, amount = 0.5) => {
  const c1 = d3.color(colorA || '#94a3b8');
  const c2 = d3.color(colorB || '#ffffff');
  if (!c1 || !c2) {
    return colorA || colorB || '#94a3b8';
  }
  return d3.interpolateRgb(c1, c2)(clamp01(amount));
};

export const toRgba = (color, alpha = 0.35, fallback = '#fbbf24') => {
  const parsed = d3.color(color || fallback);
  if (!parsed) return `rgba(251, 191, 36, ${alpha})`;
  const clone = parsed.copy();
  clone.opacity = alpha;
  return clone.formatRgb();
};

// ─── CUD配色の系列一貫性ヘルパー ──────────────────────────────────────────
// 配色プリセット変更時に同じ系列が同じ色インデックスを維持
export const getConsistentIndexFromId = (elementId) => {
  if (!elementId) return 0;
  // "bar_0_2" → "0", "line_1" → "1", "scatter_2" → "2"
  const match = elementId.match(/^[a-z_]+_(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
};
